import PropTypes from 'prop-types';
import { PRIORIDADES } from '../../features/tickets';

const PrioridadTag = ({ prioridad }) => {
  const meta = PRIORIDADES[prioridad] || { label: prioridad, color: '#94a3b8' };
  return (
    <span className="tickets-prio">
      <span
        className="tickets-prio__dot"
        style={{ backgroundColor: meta.color }}
        aria-hidden="true"
      />
      {meta.label}
    </span>
  );
};

PrioridadTag.propTypes = {
  prioridad: PropTypes.string.isRequired,
};

export default PrioridadTag;
